import * as WpsRuntime from 'DVWebNodeWpsRuntime'

export const LIVE_EVENT_DEFAULT_UX = 'Live Event Default UX'
export const LIVE_SPORTING_EVENT_UX_1 = 'Live Sporting Event UX 1'
export const LIVE_SPORTING_EVENT_UX_2 = 'Live Sporting Event UX 2'
export const LIVE_SPORTING_EVENT_UX_3 = 'Live Sporting Event UX 3'
export const EVENT = 'EVENT'

export const isLiveEntityType = (entityType?: string) =>
  entityType
    ? [
        LIVE_EVENT_DEFAULT_UX,
        LIVE_SPORTING_EVENT_UX_1,
        LIVE_SPORTING_EVENT_UX_2,
        LIVE_SPORTING_EVENT_UX_3,
        EVENT
      ].includes(entityType)
    : false

export const isTV = (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps): boolean => Boolean(detailFragment && detailFragment.entityType == 'TV Show')